/**
 * AdminLayout — full-screen layout for the Admin Web Panel.
 *
 * Dark sidebar + warm-paper main column. Mobile users see a simple "switch
 * to a wider screen" message; the panel is desktop-first by design.
 */
import { Outlet } from "react-router-dom";
import { useAuth } from "../lib/auth";
import AdminSidebar from "../components/AdminSidebar";

export default function AdminLayout() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user || user.role !== "admin") {
    return (
      <div className="min-h-screen flex items-center justify-center px-6 bg-[#FBF9F6]">
        <p
          data-testid="admin-forbidden"
          className="font-serif italic text-[#525252]"
        >
          The director panel is for workspace admins.
        </p>
      </div>
    );
  }
  return (
    <div className="min-h-screen flex bg-[#FBF9F6]" data-testid="admin-layout">
      <AdminSidebar />
      <main className="flex-1 min-w-0 lg:px-12 px-5 py-8 fade-up">
        <div className="lg:hidden mb-6 text-xs tracking-[0.18em] uppercase text-[#525252]">
          For best results, view on a wider screen.
        </div>
        <Outlet />
      </main>
    </div>
  );
}
